import { oddsFormats, formatOdds } from '@wh/odds-formatter';
export const getFormattedOdds = (oddsFormat, numerator, denominator) => {
    const key = oddsFormat.toUpperCase();
    return formatOdds(numerator, denominator, oddsFormats[key]);
};
